import React, { useState } from 'react';
import { MdCheckCircle, MdCancel, MdNotifications, MdClose, MdSend } from 'react-icons/md';
import { formatLocalDateLabel } from '../utils/notificationRecipient';

/**
 * Komponent do edycji kolejki powiadomień
 * Pozwala na odznaczenie wybranych powiadomień przed wysłaniem
 */
export default function NotificationQueueEditor({
    queue,
    onSend,
    onClose,
    onToggle,
}) {
    const [isOpen, setIsOpen] = useState(true);

    if (!isOpen || queue.length === 0) {
        return null;
    }

    const getNotificationText = (notification) => {
        const { type, eventName, date, staffName } = notification;
        const dateStr = formatLocalDateLabel(date);

        switch (type) {
            case 'add_staff':
                return `Zostałeś dodany do wydarzenia: ${eventName} (${dateStr})`;
            case 'remove_staff':
                return `Zostałeś usunięty z wydarzenia: ${eventName} (${dateStr})`;
            case 'propose_staff':
                return `Chcemy Cię dodać do wydarzenia: ${eventName} (${dateStr})`;
            default:
                return `${staffName} - ${eventName} (${dateStr})`;
        }
    };

    const getNotificationIcon = (type) => {
        switch (type) {
            case 'add_staff':
                return <MdCheckCircle className="text-green-500" size={20} />;
            case 'remove_staff':
                return <MdCancel className="text-red-500" size={20} />;
            case 'propose_staff':
                return <MdNotifications className="text-yellow-500" size={20} />;
            default:
                return <MdNotifications size={20} />;
        }
    };

    const selectedCount = queue.filter(n => n.selected).length;

    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center
                      bg-black bg-opacity-50 dark:bg-opacity-70">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl
                          max-w-2xl w-full mx-4 max-h-[80vh] flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b
                              border-gray-200 dark:border-gray-700">
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                        Edytuj powiadomienia ({selectedCount}/{queue.length} zaznaczonych)
                    </h2>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            onClose();
                        }}
                        className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                    >
                        <MdClose size={24} />
                    </button>
                </div>

                {/* Lista powiadomień */}
                <div className="flex-1 overflow-y-auto p-4">
                    <div className="space-y-2">
                        {queue.map(notif => (
                            <label
                                key={notif.id}
                                className="flex items-start gap-3 p-3 rounded border
                                        cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700
                                        border-gray-200 dark:border-gray-700
                                        bg-white dark:bg-gray-800"
                            >
                                <input
                                    type="checkbox"
                                    checked={notif.selected}
                                    onChange={() => onToggle(notif.id)}
                                    className="mt-1 w-5 h-5 text-blue-600 rounded
                                             focus:ring-blue-500 focus:ring-2"
                                />
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-1">
                                        {getNotificationIcon(notif.type)}
                                        <span className="font-medium text-gray-900 dark:text-gray-100">
                                            {notif.staffName}
                                        </span>
                                    </div>
                                    <div className="text-sm text-gray-600 dark:text-gray-400">
                                        {getNotificationText(notif)}
                                    </div>
                                    {notif.mappingError && (
                                        <div className="text-sm text-amber-700 dark:text-amber-400 mt-1">
                                            {notif.mappingError}
                                        </div>
                                    )}
                                </div>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Footer z przyciskami */}
                <div className="flex items-center justify-end gap-2 p-4 border-t
                              border-gray-200 dark:border-gray-700">
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            onClose();
                        }}
                        className="px-4 py-2 text-gray-700 dark:text-gray-300 rounded
                                 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                        Anuluj
                    </button>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            onSend();
                        }}
                        disabled={selectedCount === 0}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600
                                 disabled:bg-gray-300 disabled:cursor-not-allowed
                                 dark:bg-blue-600 dark:hover:bg-blue-700
                                 flex items-center gap-2"
                    >
                        <MdSend size={18} />
                        Wyślij zaznaczone ({selectedCount})
                    </button>
                </div>
            </div>
        </div>
    );
}


